import { useStyledBlock, StyleControls, AdvancedStyleControls } from "./StyleControls";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";
import type { ResponsiveStyleProps } from "@/lib/craft/style-props";

export function ContainerBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { style, updateStyle } = useStyledBlock<{ style?: ResponsiveStyleProps }>();
  if (tab === "content") {
    return <p className="text-xs text-muted-foreground">Legacy container wrapper.</p>;
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
  }
  return <AdvancedStyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
}
